/**
 * Created by hp on 2017/8/22.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Cell, CellBody, CellFooter, Cells, CellsTitle} from 'react-weui';
import axios from 'axios';
import {Page, WKError} from '../components';
import {WKPreload} from '../components/wk';
import {ComplainItem} from '../components/complain';
import '../css/page/ComplainCategoryPage.css';
import errorImg from '../images/no-source.png';


class ComplainCategoryPage extends Component {
    constructor() {
        super();
        this.state = {
            initialized: false,
            categories: [],
        }
    }

    componentDidMount() {
        axios.get(`/api/complain/categories`).then((res) => {
            if (res.data.code === 0) {
                this.setState({initialized: true, categories: res.data.data.complain_categories});
            }
        }).catch(error => {
            let tips = '';
            if (error.response && error.response.status === 404) {
                tips = '课程/专栏不存在';
            } else {
                tips = '服务器繁忙，稍后再试试吧';
            }
            this.props.dispatch({
                type: 'ERROR_SHOW',
                payload: {
                    tips: tips,
                    img: errorImg,
                    href: '/?fr=error',
                    btn: '回到首页'
                }
            });
            console.log(error);
        });
    }

    render() {
        const {id, type} = this.props.params;
        const {initialized, categories} = this.state;
        const {error} = this.props;

        if (error.showError) {
            return <div className="wk-inner-page"><WKError/></div>
        }
        if (!initialized) {
            return <WKPreload />
        }

        return (
            <Page className="complain-category-page">
                <div className="wk-inner-page">
                    <CellsTitle>请选择投诉反馈类别</CellsTitle>
                    <Cells>
                        {categories.map((category, index) => (
                            <ComplainItem 
                                key={index} 
                                href={`/complain/${type}/${category.value}/${id}`} 
                                title={category.desc}
                                category={category.value}
                            />
                        ))}
                    </Cells>
                </div>
            </Page>
        )
    }
}

export default connect((state) => ({
    error: state.error
}))(ComplainCategoryPage);


// WEBPACK FOOTER //
// ./src/pages/ComplainCategoryPage.js